<a *ngIf="file_model" class="grid-link" [href]="file_model.public_url??file_model.url" target="_blank" (click)="openFile($event);">{{ file_model.file_name }}</a>

